/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useStoreon } from "storeon/react";
import { SketchPicker } from "react-color";
import { SIZES } from "../../constants";

import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";

import HelpIcon from "@material-ui/icons/Help";

import Tooltip from "@material-ui/core/Tooltip";
import t from "translations";
import { useColorPrice } from "utils/price";

const Wrap = styled.div`
  margin-top: 5px;
`;

const SwitchWrap = styled.div`
  flex-basis: 80px;
  display: flex;
  justify-content: center;
`;

const DisableWrap = styled.div`
  opacity: ${props => (props.enabled ? 1 : 0.3)};
  pointer-events: ${props => (props.enabled ? "all" : "none")};
  display: flex;
  align-items: center;
  flex-basis: 206px;
  justify-content: space-between;
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-left: 5px;
  }
`;

const BackgroundColorPicker = props => {
  const { dispatch, canvas } = useStoreon("canvas");
  const [bgColor, setBgColor] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const colorPriceVal = useColorPrice(canvas?.DPE.cutZone.getSquareM2());
  const actualBgColor = canvas?.bgColor;

  useEffect(() => {
    if (canvas?.bgColor) {
      setBgColor(canvas.bgColor);
      setEnabled(canvas.bgColor !== "#fff");
    }
  }, [actualBgColor, canvas]);

  const handleSwitchChange = e => {
    const { checked } = e.target;
    if (!checked) {
      canvas.DPE.cutZone.setBackgroundColor("#fff");
      setBgColor("#fff");
    } else {
      canvas.DPE.cutZone.setBackgroundColor("#a8bb43");
      setBgColor("#a8bb43");
    }
    dispatch("price/fetch");
  };

  return (
    <Wrap>
      <Description>
        <Typography variant="subtitle2">
          {t.colorOption} <b>zzgl. {colorPriceVal.toFixed(2)}€</b>
        </Typography>
        <Tooltip title={t.colorOptionDesc}>
          <HelpIcon />
        </Tooltip>
        <SwitchWrap>
          <Switch onChange={handleSwitchChange} checked={enabled} />
        </SwitchWrap>
      </Description>

      <DisableWrap enabled={enabled}>
        <SketchPicker
          disableAlpha
          width={SIZES.leftBarOpened - SIZES.leftBar - 16 - 24}
          color={bgColor}
          css={css`
            box-shadow: none !important;
            background: none !important;
            input {
              background: #262626 !important;
              color: white !important;
              box-shadow: none !important;
            }
            span {
              color: white !important;
            }
            @media screen and (max-width: 480px) {
              width: calc(100% - 20px) !important;
              > div:first-of-type {
                padding-bottom: 35% !important;
              }
            }
          `}
          /* onChange={color => { */
          /*   /\* canvas.DPE.cutZone.setBackgroundColor(color.hex); *\/ */
          /* }} */
          onChangeComplete={color => {
            canvas.DPE.cutZone.setBackgroundColor(color.hex);
            setBgColor(color.hex);
          }}
        />
      </DisableWrap>
    </Wrap>
  );
};

export default BackgroundColorPicker;
